module.exports = __webpack_public_path__ + "media/app/assets/images/Arsenal-2-Standard-thumb-8cd2ade426ceddf29e75c33d21a0ccf4.jpg";